import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import { Link, Typography } from "@mui/material";
import Grid from "@mui/material/GridLegacy";
import { DateTime } from "luxon";

const icons = {
  fb: <FacebookIcon fontSize="small" color="primary" />,
  tw: <TwitterIcon fontSize="small" color="primary" />,
  ig: <InstagramIcon fontSize="small" color="primary" />,
  ln: <LinkedInIcon fontSize="small" color="primary" />,
};

const urls = {
  ln: "https://www.linkedin.com/company/vidlet-inc-/",
  fb: "https://www.facebook.com/TeamVidlet",
  tw: "https://twitter.com/teamvidlet/",
  ig: "https://www.instagram.com/teamvidlet/",
};

const keys = ["ln", "fb", "tw", "ig"];

export default function Footer() {
  return (
    <Grid
      container
      flexDirection="column"
      alignItems="center"
      sx={{ py: 3 }}
      spacing={1}
    >
      <Grid
        item
        container
        flexDirection="row"
        justifyContent="center"
        spacing={3}
      >
        {keys.map((key) => (
          <Grid item key={key}>
            <Link href={urls[key]} target="_blank">
              {icons[key]}
            </Link>
          </Grid>
        ))}
      </Grid>
      <Grid item container flexDirection="row" justifyContent="center">
        <Typography variant="caption" color="primary">
          &copy; {DateTime.now().toFormat("yyyy")} by Vidlet, Inc.
        </Typography>
      </Grid>
    </Grid>
  );
}
